import React from "react";
import { cn } from "utils";

const ConfirmModal = ({ className, onConfirm, onCancel, ref }) => {
  return (
    <div
      className={cn(
        "bg-white z-40 sm:h-1/3 h-1/2 rounded-3xl flex flex-col justify-between max-h-60",
        className
      )}
      ref={ref}
    >
      <div className="flex justify-between mt-4">
        <button
          onClick={() => onCancel()}
          className="bg-red-400 hover:bg-red-600 p-2 font-bold rounded-lg"
        >
          Cancel
        </button>
        <button
          onClick={() => onConfirm()}
          className="bg-green-400 hover:bg-green-600 p-2 font-bold rounded-lg"
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default ConfirmModal;
